// removed by extract-text-webpack-plugin
module.exports = {"msg":"ChatMsg_msg_3NJBQ","selfMsg":"ChatMsg_selfMsg_3ZmFf","selfWrapper":"ChatMsg_selfWrapper_3KBfY","chatMsgWrapper":"ChatMsg_chatMsgWrapper_Zo54I","selfMsgWrapper":"ChatMsg_selfMsgWrapper_3OXbp","chart":"ChatMsg_chart_1o_bX","botMsgWrapper":"ChatMsg_botMsgWrapper_2H8_H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChatMsg/ChatMsg.css
// module id = 102
// module chunks = 0